// extracted by mini-css-extract-plugin
export default {"breadcrumbWrapper":"bread-crumb_breadcrumbWrapper__wNVQ3"};